/**
 * Constants -- Shared artifact codes and configuration constants.
 * Extracted from v2.1 NX_V21_ARTIFACTS registry.
 *
 * @module shared/constants
 */

export const ARTIFACT_CODES = {
  TASK: 'TASK',
  MISSION: 'MSSN',
  INSTRUCTION: 'AUL',
  PROJECT: 'PROJ',
  LIBRARY: 'BIB',
  USER: 'USER'
};

export const EVENTS = {
  AUTH_LOGIN: 'auth:login',
  AUTH_LOGOUT: 'auth:logout',
  DATA_REFRESH: 'data:refresh',
  NAV_CHANGE: 'nav:change'
};
